<script setup lang="ts">
import { object, string, ref as yupRef, type InferType } from 'yup'
import type { FormSubmitEvent } from '@nuxt/ui'
import {useAuthStore} from "~~/stores/auth";

const { t } = useI18n()
const localePath = useLocalePath()
const auth = useAuthStore()
const router = useRouter()
const toast = useToast()

const schema = object({
    name: string().required(t('partials.form.required')),
    surname: string().required(t('partials.form.required')),
    email: string().email(t('partials.form.emailInvalid')).required(t('partials.form.required')),
    password: string().required(t('partials.form.required')),
    password_confirmation: string()
        .required(t('partials.form.required'))
        .oneOf([yupRef('password')], t('partials.form.passwordsMismatch')),
})

type Schema = InferType<typeof schema>

const state = reactive({
    name: undefined,
    surname: undefined,
    email: undefined,
    password: undefined,
    password_confirmation: undefined,
})

async function onRegistrationSubmit(payload: FormSubmitEvent<Schema>) {
    try {
        await auth.register(payload.data)
        await router.push(localePath('moj-racun'))
    } catch (error: any) {
        toast.add({
            title: t('userProfile.login.registrationUnsuccessful'),
            description: error?.data?.message
                || error?.data?.errors?.email?.[0]
                || error?.data?.errors?.password?.[0]
                || error?.message
                || t('userProfile.login.registrationUnsuccessful'),
            color: 'error'
        })
    }
}
</script>

<template>
    <div class="flex flex-col gap-18">
        <UForm :schema="schema" :state="state" class="registration-form space-y-8 z-1 w-full" @submit="onRegistrationSubmit">
            <div class="flex flex-col gap-4">
                <div class="flex flex-row gap-4">
                    <UFormField label="Ime" name="name" class="flex-1">
                        <UInput v-model="state.name" :placeholder="t('userProfile.login.name')" class="w-full" />
                    </UFormField>
                    <UFormField label="Priimek" name="surname" class="flex-1">
                        <UInput v-model="state.surname" :placeholder="t('userProfile.login.surname')" class="w-full"/>
                    </UFormField>
                </div>
                <UFormField label="Elektronski naslov" name="email" class="flex-1">
                    <UInput v-model="state.email" :placeholder="t('userProfile.login.email')" class="w-full"/>
                </UFormField>
                <UFormField label="Geslo" name="password" class="flex-1">
                    <UInput v-model="state.password" type="password" :placeholder="t('userProfile.login.password')" class="w-full"/>
                </UFormField>
                <UFormField label="Geslo" name="password_confirmation" class="flex-1">
                    <UInput v-model="state.password_confirmation" type="password" :placeholder="t('userProfile.login.confirmPassword')" class="w-full"/>
                </UFormField>
                <UButton type="submit" class="w-fit">{{ t('userProfile.login.register') }}</UButton>
            </div>
        </UForm>
    </div>
</template>

<style>
.registration-form {
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active{
        -webkit-background-clip: text;
        -webkit-text-fill-color: #222222;
        transition: background-color 5000s ease-in-out 0s;
        box-shadow: inset 0 0 20px 20px #F9D9D7;
    }
    input {
        background-color: #F9D9D7 !important;
        &:placeholder-shown {
            background-color: #ffffff !important;
        }
    }
}
</style>
